import {createAction, handleActions} from 'redux-actions';

const FETCH = '@nezzokontikifrontend/Tags/FETCH';
const FETCH_FAILED = '@nezzokontikifrontend/Tags/FETCH_FAILED';
const SET = '@nezzokontikifrontend/Tags/SET';

export const actionTypes = {
	FETCH,
	FETCH_FAILED,
	SET
};

const fetch = createAction(FETCH, (tagGroups, isOr) => {
	if(!isOr){
		isOr = false;
	}
	return {tagGroups: tagGroups, isOr: isOr};
});

const fetchFailed = createAction(FETCH_FAILED, message => message);

const set = createAction(SET, tags => tags);

export const actions = {
	fetch,
	fetchFailed,
	set
};

const defaultState = {
	tags: [],
	errors: []
};

export const reducer = handleActions({
	[FETCH]: (state) => {
		return {...state};
	},
	[FETCH_FAILED]: (state, action) => {
		return {...state, tags: [], errors: state.errors.concat(action.payload.message)};
	},
	[SET]: (state, action) => {
		return {...state, tags: action.payload.data};
	},
}, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/tag.js